// @flow
import api from 'tim-api';
import {
  quizz as quizzEndpoint, relatedChannels, relatedRegionals, createQuizz, storeQuizz, relatedUsers
} from 'endPoints';
import { serialize } from 'utils';

const initialState = () => ({
  form: {},
  quizz: [],
  channels: [],
  regionals: [],
  users: [],
  duplicateForm: {},
  pagination: {}
});

export const state: Object = initialState();

export const getters = {
  form: (state: Object) => state.form,
  quizz: (state: Object) => state.quizz || [],
  pagination: (state: Object) => state.pagination || {},
  duplicateForm: (state: Object) => state.duplicateForm || {}
};

export const mutations = {
  SET_FORM(state: Object, payload: Object): void {
    state.form = {
      ...state.form,
      ...payload
    };
  },
  SET_QUIZZ(state: Object, quizz: Array<Object>): void {
    state.quizz = quizz;
  },
  SET_CHANNELS(state: Object, channelsArr: Array<Object>) {
    state.channels = channelsArr;
  },
  SET_REGIONALS(state: Object, regionalsArr: Array<Object>) {
    state.regionals = regionalsArr;
  },
  RESET_STATE(state: Object) {
    Object.assign(state, initialState());
  },
  SET_DUPLICATE(state: Object, payload: Object): void {
    state.duplicateForm = {
      ...state.duplicateForm,
      ...payload
    };
  },
  SET_USERS(state: Object, payload: Array<number>) {
    state.users = payload;
  },
  SET_PAGINATION(state: Object, pagination: Object) {
    state.pagination = pagination;
  }
};

export const actions = {
  setForm({ commit }: Action, payload: Object): void {
    commit('SET_FORM', payload);
  },

  fetchQuizz({ commit }: Action, objectQuery: Quizz) {
    const query = serialize(objectQuery);

    return api.get(`${quizzEndpoint}?${query}`)
      .then(({ data: { data, ...pagination } = {} }) => {
        commit('SET_QUIZZ', data);
        commit('SET_PAGINATION', pagination);
      });
  },

  deleteQuizz(store: any, id: number) {
    return api.delete(`${quizzEndpoint}/${id}`);
  },

  fetchUsers({ commit }: Action, { concat, ...postOptions }: Object) {
    return api.post(relatedUsers, postOptions)
      .then(({ data }) => {
        const usersArr = concat ? [...data.data, ...concat] : data.data;

        commit('SET_USERS', usersArr);
        return usersArr;
      });
  },

  resetUsers({ commit }: Action) {
    commit('SET_USERS', []);
  },

  fetchChannels({ commit }: Object) {
    api.get(relatedChannels)
      .then(({ data }) => { commit('SET_CHANNELS', data.data); });
  },

  fetchRegionals({ commit }: Object) {
    api.get(relatedRegionals)
      .then(({ data }) => { commit('SET_REGIONALS', data.data); });
  },

  resetState({ commit }: Object) {
    commit('RESET_STATE');
  },

  createQuizz({ dispatch }: Action, { payload, store }: CreateQuizzObject) {
    return api.post(createQuizz, {
      quizz_form: payload
    })
      .then(({ data }) => dispatch('storeQuizz', {
        id: data.data.id,
        store
      }));
  },

  storeQuizz(context: Action, { id, store }: StoreQuizzObject) {
    return api.post(storeQuizz, {
      quizz_form: {
        quizz_id: id,
        ...store
      }
    });
  },

  fetchDuplicatedQuizz({ commit, dispatch }: Action, { id, createFrontData }: Object): Promise<Array<Object>> {
    return dispatch('fetchQuizzByID', id)
      .then(([quizz, availableFor]) => {
        commit('SET_DUPLICATE', createFrontData(quizz, availableFor));
        return [quizz, availableFor];
      });
  },

  fetchQuizzByID(context: Action, id: number): Promise<Array<Object>> {
    const requests: Array<Promise<Object>> = [
      api.get(`/quizz/${id}`), // fetch quizz infos
      api.get(`/quizz/available-for/${id}`) // fetch quizz availability
    ];

    return Promise.all(requests)
      .then(([quizz, availableFor]) => [quizz.data.data, availableFor.data.data]);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
